import { Skeleton } from '@material-ui/lab'

import { useStyles } from './styles'

export default function CustomSkeleton() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.wrapperCards}>
        <Skeleton variant='rect' height={88} role='progressbar' />
        <Skeleton variant='rect' height={88} role='progressbar' />
        <Skeleton variant='rect' height={88} role='progressbar' />
        <Skeleton variant='rect' height={88} role='progressbar' />
      </div>
      <div className={classes.wrapperCharts}>
        <Skeleton variant='rect' height={360} role='progressbar' />
        <Skeleton variant='rect' height={360} role='progressbar' />
      </div>
    </div>
  )
}
